import React from "react";
import { Link } from "react-router-dom";
import { Trophy, Flame, CircleCheck } from "lucide-react";
import { blogPosts } from "../data/blogsposts";
import "./BlogHighlights.css";

export default function BlogHighlights() {
  const featuredSlugs = [
    "mejores-apps-contar-calorias-2026",
    "alimentos-bajos-calorias-perder-peso",
    "cuantas-calorias-debo-comer-al-dia"
  ];

  const highlightMeta = {
    "mejores-apps-contar-calorias-2026": { Icon: Trophy, texto: "RECOMENDADO" },
    "alimentos-bajos-calorias-perder-peso": { Icon: Flame, texto: "MÁS LEÍDO" },
    "cuantas-calorias-debo-comer-al-dia": { Icon: CircleCheck, texto: "GUÍA CLAVE" }
  };

  const featured = featuredSlugs
    .map(slug => blogPosts.find(p => p.slug === slug))
    .filter(Boolean);

  return (
    <section className="blog-highlights">
      <div className="blog-highlights-container">
        <div className="blog-highlights-header">
          <span className="blog-highlights-badge">BLOG</span>
          <h2 className="blog-highlights-title">
            Aprende a comer mejor
          </h2>
          <p className="blog-highlights-subtitle">
            Artículos prácticos sobre nutrición, pérdida de peso y hábitos saludables
          </p>
        </div>

        <div className="blog-highlights-grid">
          {featured.map(post => {
            const { Icon, texto } = highlightMeta[post.slug];
            return (
            <Link
              key={post.id}
              to={`/blog/${post.slug}`}
              className="blog-highlight-card"
            >
              <div className="blog-highlight-image">
                <img src={post.image} alt={post.title} loading="lazy" />
                <span className="blog-highlight-category">{post.category}</span>
                <span className="blog-highlight-tag">
                  <Icon size={13} strokeWidth={2.5} aria-hidden="true" />
                  {texto}
                </span>
              </div>
              <div className="blog-highlight-content">
                <h3>{post.title}</h3>
                <p>{post.excerpt}</p>
                <span className="blog-highlight-read">{post.readTime} de lectura</span>
              </div>
            </Link>
            );
          })}
        </div>

        <div className="blog-highlights-cta">
          <Link to="/blog" className="blog-highlights-btn">
            Ver todos los artículos
          </Link>
        </div>
      </div>
    </section>
  );
}
